import React from 'react';
import { Box, ChevronRightIcon, RawButton, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

const ButtonContent = styled(Box)`
  svg {
    transition: margin-left 0.4s ease;
  }

  &:hover {
    svg {
      margin-left: ${({ theme }) => theme.spacings.spacing6};
    }

    span {
      text-decoration: underline;
    }
  }
`;

interface Props {
  value?: string;
  onClick?: () => void;
}

const ClaimSummaryFieldValue: React.FC<Props> = ({ value, onClick }) => {
  return (
    <RawButton data-testid="claim-summary-field_value" onClick={onClick}>
      <ButtonContent
        direction="row"
        align="center" 
        width={{ max: '232px' }}
      >
        <Text
          weight={700}
          size="20px"
          color="success"
          title={value}
          className="ellipsis-text"
        >
          {value}
        </Text>
        <Box margin={{ left: 'spacing8' }} width="20px">
          <ChevronRightIcon />
        </Box>
      </ButtonContent>
    </RawButton>
  );
};

export default ClaimSummaryFieldValue;
